/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 27-07-2026
 *
 * Stelt de max-height van het element zo in dat de onderkant nooit lager komt dan de onderkant van
 * `#cytocanvasholder`. Port van de gelijknamige AngularJS-directive (golf f1).
 *
 * De berekening gebeurt na de eerste render en bij elke window-resize; het element is dan al
 * geplaatst, zodat zijn eigen positie meetelt.
 */
import {AfterViewInit, Directive, ElementRef, HostListener, Input, inject} from '@angular/core';

@Directive({
    selector: '[dlMaxHoogteCanvas]',
    standalone: true
})
export class DlMaxHoogteCanvasDirective implements AfterViewInit {

    /**
     * Het element waarvan we de hoogte begrenzen.
     */
    private readonly element: HTMLElement = inject(ElementRef).nativeElement;

    /**
     * De marge die we boven de onderkant van het canvas vrijhouden.
     */
    @Input()
    marge = 8;

    ngAfterViewInit(): void {
        this.pasMaxHoogteAan();
    }

    @HostListener('window:resize')
    protected opResize(): void {
        this.pasMaxHoogteAan();
    }

    /**
     * Berekent en zet de max-height op basis van de huidige positie van het element ten opzichte van
     * de onderkant van het canvas.
     */
    private pasMaxHoogteAan(): void {
        const canvas = document.getElementById('cytocanvasholder');
        if (!canvas) {
            return;
        }
        const beschikbaar = canvas.getBoundingClientRect().bottom - this.element.getBoundingClientRect().top - this.marge;
        if (beschikbaar > 0) {
            this.element.style.maxHeight = `${beschikbaar}px`;
        }
    }
}
